import {Badge, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export const VoucherTransferBadge: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Badge variant="info" size="sm">
      <Icon name="ticket" className="size-3" />
      {t('view.payouts.list.transferTypes.voucher')}
    </Badge>
  );
};
